import { render, staticRenderFns } from "./andonOrderDetail.vue?vue&type=template&id=74123729&scoped=true"
import script from "./andonOrderDetail.vue?vue&type=script&lang=js"
export * from "./andonOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./andonOrderDetail.vue?vue&type=style&index=0&id=74123729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74123729",
  null
  
)

export default component.exports